import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Altura del header fijo (ajustar si cambia el diseño)
const HEADER_HEIGHT = 80

const ScrollToHash = () => {
  const location = useLocation()

  useEffect(() => {
    // Si hay hash en la URL
    if (location.hash) {
      // Usar setTimeout para asegurar que el DOM está listo
      setTimeout(() => {
        const id = location.hash.replace('#', '')
        const element = document.getElementById(id)

        if (element) {
          // Calcular posición con offset para el header fijo
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition = elementPosition + window.pageYOffset - HEADER_HEIGHT

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      }, 100)
    } else {
      // Si no hay hash, scroll to top
      window.scrollTo(0, 0)
    }
  }, [location])

  return null
}

export default ScrollToHash
